"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "content-wrapper d-flex flex-wrap" };
const _hoisted_2 = ["onClick"];
const vue_3 = require("vue");
const models_1 = require("../../../js/models");
const Modal_vue_1 = __importDefault(require("../../../vue/Modal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesModal',
    emits: ["close-modal", "selected-role-id"],
    setup(__props, { emit: __emit }) {
        const roleStore = (0, vue_3.inject)("roleStore");
        const selectedRole = (0, vue_3.ref)(null);
        const roles = (0, vue_3.computed)(() => {
            return roleStore?.query() || [];
        });
        const emits = __emit;
        function closeRolesModal() {
            emits("close-modal");
        }
        function handleRoleSelect(role) {
            if (selectedRole.value?.getId() === role.getId()) {
                selectedRole.value = null;
                return;
            }
            selectedRole.value = role;
            emits("selected-role-id", parseInt(role.getId()));
        }
        function roleStyle(role) {
            const isActive = selectedRole.value?.getId() === role.getId();
            if (isActive) {
                return {
                    backgroundColor: "#4897c9",
                    color: "#fff",
                };
            }
            return {
                backgroundColor: `#${role.color ? role.color : models_1.OPLUS_COLOR_PALETTE.DEFAULT}`,
                color: role.color ? "#fff" : "",
            };
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                onCloseModal: closeRolesModal,
                "has-title-divider": true,
                "has-footer-divider": false
            }, {
                "header-title": (0, vue_2.withCtx)(() => [...(_cache[0] || (_cache[0] = [
                        (0, vue_2.createElementVNode)("span", { class: "header-text" }, " 業務 ", -1 /* CACHED */)
                    ]))]),
                content: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(roles.value, (r) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: r.getId()
                            }, [
                                (0, vue_2.createElementVNode)("div", {
                                    onClick: ($event) => (handleRoleSelect(r)),
                                    class: (0, vue_2.normalizeClass)(["chip c-hand spot-role-chip", { active: selectedRole.value?.getId() === r.getId() }]),
                                    style: (0, vue_2.normalizeStyle)(roleStyle(r))
                                }, (0, vue_2.toDisplayString)(r.getName()), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_2)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
